import React, { useState } from "react";
import {
  Wrapper,
  ButtonWrapper,
  Box,
  Check,
  Shadow,
  Input,
  Label,
} from "./styled";

const Radio = ({
  name,
  label,
  value,
  checkedValue,
  setCheckedValue,
  disabled,
  error,
  id,
}) => {
  const [animate, setAnimate] = useState(false);
  const [focus, setFocus] = useState(false);

  const animateButton = () => {
    setAnimate(!animate);
    setTimeout(() => setAnimate(false), 400);
  };

  const onCheck = (animate = true) => {
    if (!disabled) {
      animate && animateButton();
      setCheckedValue(value);
    }
  };

  return (
    <Wrapper>
      <ButtonWrapper
        onClick={onCheck}
        disabled={disabled}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className={focus ? "focusEffect" : ""}
        aria-label={label || "Radiobutton"}
      >
        <Box disabled={disabled} error={error}>
          <Check checked={value && value === checkedValue} />
        </Box>
        <Shadow className={animate ? "animate" : ""} focus={focus} />
        <Input
          type="radio"
          name={name}
          id={id}
          checked={value && value === checkedValue}
          onChange={onCheck}
          disabled={disabled}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          value={label}
          aria-checked={value === checkedValue ? "true" : "false"}
        />
      </ButtonWrapper>
      {label && (
        <Label
          htmlFor={id}
          onClick={() => onCheck(false)}
          disabled={disabled}
          error={error}
        >
          {label}
        </Label>
      )}
    </Wrapper>
  );
};

export default Radio;
